
import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import axios from "src/app/Service/axios";

import * as XLSX from 'xlsx';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;

@Component({

  selector: 'app-financial-report',

  templateUrl: './financial-report.component.html',

  styleUrls: ['./financial-report.component.css']

})

export class FinancialReportComponent implements OnInit {

  list_financialReport: any = [];

  list_search: any = [];

  lstPassenger: any = [];

  iTotalDebit = 0;

  iTotalCredit = 0;

  iTotalBalance = 0;

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.getList_Financial()

  }

  async getList_Financial() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_DebitCredit_Financial_Report`, model)).data.toString());

    res.forEach((a: any) => {

      this.iTotalDebit += a.iDebit;

      this.iTotalCredit += a.iCredit;

      this.iTotalBalance += a.iBalance;
    })

    this.list_financialReport = res;

    this.list_search = res;

  }

  async sendMessage(form: NgForm) {

    if (form.value.strMessage == '') return this.Notification.showError('لطفا متن پیام را مشخص کنید');

    if (!form.value.bSendPush && !form.value.bSaveMessage) return this.Notification.showError('لطفا نحوه ارسال پیام را مشخص کنید');

    form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value['lstPassenger'] = this.lstPassenger;

    let res = JSON.parse((await axios.post(`School_Passenger_SendMessage`, form.value)).data.toString());

    if (res.iResult) {

      $('#sendMessage').modal('hide');

      return this.Notification.showSuccess('پیام با موفقیت ارسال شد');
    }

    else return this.Notification.showError(res.strError)


  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_financialReport = this.list_search.filter((el: any) => {

        return el.strMobileDomain_strComment?.includes(search) || el.strGrade?.includes(search) || el.strPassenger_FullName?.includes(search)

      })
    }

    else if (search == '') this.list_financialReport = this.list_search;

    this.iTotalDebit = 0;

    this.iTotalCredit = 0;

    this.iTotalBalance = 0;

    this.list_financialReport.forEach((a: any) => {

      this.iTotalDebit += a.iDebit;

      this.iTotalCredit += a.iCredit;

      this.iTotalBalance += a.iBalance;
    })


  }

  selectAllCheckBox() {

    if (this.list_financialReport.length > 0 && (this.list_financialReport.length != this.lstPassenger.length)) {

      this.lstPassenger = [];

      this.list_financialReport.forEach((a: any) => {

        this.lstPassenger.push(a.iPassenger);

      })

      this.Notification.showSuccess('همه دانش آموزان انتخاب شدند')

    }

    else {

      this.lstPassenger = [];

    }

  }

  isSelected(item: any): boolean {

    return this.lstPassenger.indexOf(item) !== -1;
  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstPassenger.push(item.iPassenger);

    else {

      this.lstPassenger.find((value: any) => {

        if (value === item.iPassenger) {

          const index = this.lstPassenger.indexOf(item.iPassenger);

          if (index !== -1) this.lstPassenger.splice(index, 1);

        }

      })
    }

  }

  message_Modal() {

    if (this.lstPassenger.length == 0) return this.Notification.showError('لطفا دانش آموز مورد نظر خود را انتخاب کنید');

    $('#sendMessage').modal('show')

  }

  goBack() {

    this.router.navigate(['/'])

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'گزارش مالی.xlsx');

    }, 200);

  }

}
